import technicalEvents from '../datas/technical.js'
import nonTechnicalEvents from '../datas/non-technical.js'
import { useParams } from 'react-router-dom'

export default function ViewEvent() {
    const { type, eventName } = useParams()
    const eventDetails =
        type === 'technical' 
            ?technicalEvents.find(event => event.name === eventName)
            :nonTechnicalEvents.find(event => event.name === eventName);
    

    return (<div className='event-det-main'>
        <div className="event-det-details">
            <div className="left-det">
                <div className="event-det-name">{eventDetails.name}</div>
                <div className="event-det-description">{ eventDetails.description }</div>
                <div className="event-det-date">{eventDetails.date}</div>
                <div className="event-det-timings">{eventDetails.timings}</div>
            </div>
            <div className="right-det">
                <img src={eventDetails.img} alt={eventDetails.img} />
            </div>
        </div>
        <div className='register-event'><span className="pink">&lt;</span>Register <span className="pink">/&gt;</span></div>
    </div>)
}